import { Component, EventEmitter, Input, Output } from '@angular/core';

import { allowNumericInputOnly } from '../../utils';

@Component({
  selector: 'app-date-of-birth',
  templateUrl: './date-of-birth.component.html',
  styleUrls: ['./date-of-birth.component.scss'],
  standalone: false
})
export class DateOfBirthComponent {
  allowNumericInputOnly = allowNumericInputOnly;

  @Input() savedDOB: string[] = ['', '', ''];
  @Input() invalidDate: boolean;
  @Output() changedDOB = new EventEmitter<string[]>();

  saveDOB(event: Event, type: 'day' | 'month' | 'year'): void {
    const { value } = event.target as HTMLInputElement;

    switch (type) {
      case 'year':
        this.savedDOB[0] = value;
        break;
      case 'month':
        this.savedDOB[1] = value;
        break;
      case 'day':
        this.savedDOB[2] = value;
        break;
      default:
        break;
    }

    this.changedDOB.emit(this.savedDOB);
  }
}
